import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_SALARY_TYPES } from './get-salary-types.hook';
import { GET_SALARY_TYPES_BY_IDS } from './get-salary-types-by-ids.hook';
import { GET_SALARY_TYPE_BY_ID } from './get-salary-types-by-id.hook';
import { GET_ALL_SALARY_TYPES } from './get-all-salary-types.hook';



export const CREATE_SALARY_TYPES = gql`
  mutation createHealthInsurance($payload: CreateSalaryTypesInput!) {
    createSalaryTypes(payload: $payload) {
      _id
      name
      companyId
    }
  }
`;

export const useCreateSalaryTypes = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('settings');
  const [createSalaryTypes, { loading }] = useMutation(CREATE_SALARY_TYPES, {
    onCompleted: data => {
      if (data?.createSalaryTypes?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('salaryTypes.notifications.created'),
        });
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    refetchQueries: [
      GET_SALARY_TYPES,
      GET_SALARY_TYPES_BY_IDS,
      GET_SALARY_TYPE_BY_ID,
      GET_ALL_SALARY_TYPES,
    ],
  });
  return { createSalaryTypes, loading };
};
